export default class UrlHelper {

	/**
     * Get param value from param name.
     * @param {string} param
     * @returns {string|string}
     */
	static getUrlParam(param){
		param = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}
}